module.exports = __webpack_public_path__ + "fonts/苹方-Medium.15974853.ttf";